import Modal from "antd/lib/modal/Modal";
import React, { createContext, useContext, useState } from "react";
import { Button, DatePicker, Space, Form, notification } from "antd";
import QuaiboDailyProductionStore from "../store/quaibodailyproductionstore";
import { observer } from "mobx-react-lite";
import { ProgressIndicator } from "@fluentui/react";
const { RangePicker } = DatePicker;
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const QuaiboWellAllocationExport = observer(() => {
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const [podExportDate, setPodExportDate] = useState(null);
  return (
    <Modal
      visible={quaiboDailyProductionStore.showWellAllocationExportDialog}
      title={"Select Quaibo Productions/Well Allocations Export Date Range"}
      onCancel={() => {
        quaiboDailyProductionStore.showWellAllocationExportDialog = false;
      }}
      centered
      footer={
        <Space>
          {quaiboDailyProductionStore.isExporting && (
            <ProgressIndicator
              description="exporting, please wait..."
              styles={{ root: { width: "200px", textAlign: "left" } }}
            />
          )}
          <Button
            type="link"
            onClick={() => {
              quaiboDailyProductionStore.showWellAllocationExportDialog = false;
            }}
          >
            Close
          </Button>
          <Button
            type="primary"
            loading={quaiboDailyProductionStore.isExporting}
            disabled={podExportDate === null}
            onClick={async () => {
              try {
                quaiboDailyProductionStore.exportWellAllocation(podExportDate);
              } catch (error) {
                notification.error({
                  message: "SPARS Feedback",
                  description: error.message,
                });
              }
            }}
          >
            Export
          </Button>
        </Space>
      }
    >
      <Form layout="vertical" name="basic">
        <Form.Item>
          <RangePicker
            placeholder={[
              "Refer (Production) Start Date",
              "Refer (Production) End Date",
            ]}
            style={{ width: "95%" }}
            onChange={(dateObj, dateStringArr) => {
              setPodExportDate(dateObj);
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});

